export default __webpack_public_path__ + "static/media/btn_revoquer_droits.aeb9a99b.svg";